<template src="./Error404.html"></template>
<style scoped src="./Error404.scss" lang="scss"></style>
<script>
import Errormsg from "@/components/Errormsg/";

export default {
  name: "Error404",
  data() {
    return {
      msg: "XX"
    };
  },
  components: {
    "app-errormsg": Errormsg
  }
};
</script>
